export const getFormatterMobileNumber = number => {
  if (number.length !== 8) return number
  return (
    number[0] +
    number[1] +
    number[2] +
    '\u00a0' +
    number[3] +
    number[4] +
    '\u00a0' +
    number[5] +
    number[6] +
    number[7]
  )
}

export const getFormattedOrgNumber = number => {
  if (number.length !== 9) return number
  return (
    number[0] +
    number[1] +
    number[2] +
    '\u00a0' +
    number[3] +
    number[4] +
    number[5] +
    '\u00a0' +
    number[6] +
    number[7] +
    number[8]
  )
}
